

import { useToastDispatchContext } from '../MyComponents/Toast/ToastContext';

export function useToast() {
  const dispatch = useToastDispatchContext();

  function toast(type, message) {
    const id = Math.random().toString(36).slice(2, 9);
    dispatch({ type: 'ADD_TOAST', toast: { type, message, id } });

    setTimeout(() => {
      dispatch({ type: 'DELETE_TOAST', id: id });
    }, 4000);
    //}, 120000);
  }

  return toast;
}